import React from 'react';

import {skeletonBlock} from './skeleton-block.module.styl';

type Props = {
    width: number,
    height: number,
    radius?: number,
    className?: string,
};

export const SkeletonBlock: React.FC<Props> = ({
    width,
    height,
    radius = 4,
}) => {

    return (
        <div
            className={skeletonBlock}
            style={{
                width,
                height,
                borderRadius: radius,
            }}
        />
    );
};
